<frontend-pull-refresh></frontend-pull-refresh>

<section class="pl-3 pb-3">
  <h1 class="pt-3 mb-3">Notifications</h1>
  <form *ngIf="notificationsForm" [formGroup]="notificationsForm" (ngSubmit)="submit()" class="pr-3">
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label class="col-form-label lead">Dynamic Fields</label>
        <p>Use these in your messages to fill in information in your notifications on the fly.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
      <span
        class="btn btn-info m-1 p-1 white"
        *ngFor="let field of dynamicFieldOptions"
        [ngbTooltip]="field.toolTip"
        placement="top"
      >
        {{"{" + field.name + "}"}}
      </span>
      </div>
    </div>

    <div *ngIf="account.features.whatsApp" class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-use-whats-up" class="col-form-label lead">Add per-{{location.displayOptions?.labels?.customer || 'customer'}} option to send notifications via WhatsApp</label>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
            <input
              id="settings-use-whats-up"
              type="checkbox"
              class="form-check-input"
              name="useWhatsApp"
              formControlName="useWhatsApp"
            > Enabled
          </label>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-sms-msg" class="col-form-label lead">Ready Notification - SMS</label>
        <p>Your alert message that you're ready. This is a good place to ask someone to reply to confirm or cancel.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2 d-flex flex-column">
        <div>
        <textarea
          name="text"
          class="w-100 form-control"
          id="settings-sms-msg"
          rows="5"
          replace-smart-punctuation
          formControlName="smsPageMessage"
          notify-channel="sms"
          #smsPageMessage
          [class.is-invalid]="notificationsForm.get('smsPageMessage').invalid && notificationsForm.get('smsPageMessage').touched"
          trTrimSpaces
        ></textarea>
          <control-messages [control]="notificationsForm.get('smsPageMessage')"></control-messages>
          <sms-warning [message]="smsPageMessage.value"></sms-warning>
          <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="smsPageMessage.value"></chat-counter>
        </div>
      </div>
    </div>

    <div class="row form-group" formGroupName="voicePageNotification">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-voice-page-notification" class="col-form-label lead">Ready Notification - Voice</label>
        <p>A computerized voice will read this message when you call. Use phonetic spelling if a word isn't pronounced correctly.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
            <input
              type="checkbox"
              class="form-check-input"
              name="voicePageNotificationEnabled"
              id="settings-voice-page-notification"
              (ngModelChange)="toggleTextarea($event, 'voicePageNotification')"
              formControlName="enabled">Enabled
          </label>
        </div>
        <div *ngIf="notificationsForm.get('voicePageNotification.enabled').value">
          <div>
          <textarea
            name="voicePageNotificationMessage"
            class="w-100 form-control"
            rows="5"
            replace-smart-punctuation
            formControlName="message"
            notify-channel="voice-page-message"
            #voicePageNotificationMessage
            [class.is-invalid]="notificationsForm.get('voicePageNotification.message').invalid && notificationsForm.get('voicePageNotification.message').touched"
            trTrimSpaces
          ></textarea>
            <control-messages [control]="notificationsForm.get('voicePageNotification.message')"></control-messages>
            <chat-counter [maxAnsiChars]="voiceChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="voicePageNotificationMessage.value"></chat-counter>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group" formGroupName="smsReply">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-sms-reply" class="col-form-label lead">Default SMS Reply</label>
        <p>Reply with this message anytime someone texts you to confirm that you received it and will see it.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
            <input type="checkbox"
                   id="settings-sms-reply"
                   class="form-check-input"
                   name="defaultSmsReplyEnabled"
                   (ngModelChange)="toggleTextarea($event, 'smsReply')"
                   formControlName="enabled">Enabled
          </label>
        </div>
        <div *ngIf="notificationsForm.get('smsReply.enabled').value">
          <div>
          <textarea
            name="smsReply"
            class="w-100 form-control"
            rows="5"
            replace-smart-punctuation
            formControlName="message"
            notify-channel="sms-reply"
            #smsReplyMessage
            [class.is-invalid]="notificationsForm.get('smsReply.message').invalid && notificationsForm.get('smsReply.message').touched"
            trTrimSpaces
          ></textarea>
            <control-messages [control]="notificationsForm.get('smsReply.message')"></control-messages>
            <sms-warning [message]="smsReplyMessage.value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="smsReplyMessage.value"></chat-counter>
          </div>
        </div>
      </div>
    </div>
    <div class="row form-group" formGroupName="smsConfirmation">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-sms-confirmation" class="col-form-label lead">Waitlist Confirmation SMS</label>
        <p>Sent automatically when you add someone to your waitlist. You can add the link to your public waitlist so people can check their place in line.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
            <input
              type="checkbox"
              id="settings-sms-confirmation"
              class="form-check-input"
              name="defaultConfirmationEnabled"
              (ngModelChange)="toggleTextarea($event, 'smsConfirmation')"
              formControlName="enabled">Enabled
          </label>
        </div>
        <div *ngIf="notificationsForm.get('smsConfirmation.enabled').value">
          <div>
          <textarea
            name="smsConfirmation"
            class="w-100 form-control"
            rows="5"
            replace-smart-punctuation
            formControlName="message"
            notify-channel="sms-confirmation"
            #smsConfirmationMessage
            [class.is-invalid]="notificationsForm.get('smsConfirmation.message').invalid && notificationsForm.get('smsConfirmation.message').touched"
            trTrimSpaces
          ></textarea>
            <control-messages [control]="notificationsForm.get('smsConfirmation.message')"></control-messages>
            <sms-warning [message]="smsConfirmationMessage.value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="smsConfirmationMessage.value"></chat-counter>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group" formGroupName="smsWaitlistCancellation">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-sms-res-conf" class="col-form-label lead">Waitlist Cancellation SMS</label>
        <p>Sent automatically when a party is canceled.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
            <input
              type="checkbox"
              class="form-check-input"
              name="smsWaitlistCancellation"
              id="settings-sms-waitlist-cancellation"
              (ngModelChange)="toggleTextarea($event, 'smsWaitlistCancellation')"
              formControlName="enabled">Enabled
          </label>
        </div>
        <div *ngIf="notificationsForm.get('smsWaitlistCancellation.enabled').value">
          <div>
          <textarea
            name="smsWaitlistCancellation"
            class="w-100 form-control"
            rows="5"
            replace-smart-punctuation
            formControlName="message"
            notify-channel="sms-reservation-cancellation"
            #smsWaitlistCancellationMessage
            [class.is-invalid]="notificationsForm.get('smsWaitlistCancellation.message').invalid && notificationsForm.get('smsWaitlistCancellation.message').touched"
            trTrimSpaces
          ></textarea>
            <control-messages [control]="notificationsForm.get('smsWaitlistCancellation.message')"></control-messages>
            <sms-warning [message]="smsWaitlistCancellationMessage.value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="smsWaitlistCancellationMessage.value"></chat-counter>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group" formGroupName="smsNext">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-sms-next" class="col-form-label lead">Next-in-line SMS</label>
        <p>Sent automatically when it's almost someone's turn.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label flex-wrap">
            <input type="checkbox"
                   class="form-check-input"
                   name="smsNextEnabled"
                   id="settings-sms-next"
                   (ngModelChange)="toggleTextarea($event, 'smsNext')"
                   formControlName="enabled">Send this when someone is &nbsp;
            <select formControlName="position" name="smsNextPosition">
              <option *ngFor="let option of this.positionInLineOptions" [ngValue]="option.value">{{ option.name }}</option>
            </select>
            &nbsp;in line.
          </label>
        </div>
        <div *ngIf="notificationsForm.get('smsNext.enabled').value">
          <div>
          <textarea
            name="smsNext"
            class="w-100 form-control"
            rows="5"
            replace-smart-punctuation
            formControlName="message"
            notify-channel="sms-next"
            #smsNextMessage
            [class.is-invalid]="notificationsForm.get('smsNext.message').invalid && notificationsForm.get('smsNext.message').touched"
            trTrimSpaces
          ></textarea>
            <control-messages [control]="notificationsForm.get('smsNext.message')"></control-messages>
            <sms-warning [message]="smsNextMessage.value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="smsNextMessage.value"></chat-counter>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group" formGroupName="smsCompleted">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-sms-reply" class="col-form-label lead">Completed/Follow-Up SMS</label>
        <p>Send this message automatically a set time after you mark someone as "Served." Use this with care.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
          <span>
            <input type="checkbox"
                   class="form-check-input"
                   name="smsCompletedEnabled"
                   id="settings-sms-completed"
                   (ngModelChange)="toggleTextarea($event, 'smsCompleted')"
                   formControlName="enabled">
          </span>
            <span>
            Send this
          <select formControlName="timeValue" class="ml-1" name="smsCompletedTimeValue">
            <option *ngFor="let option of this.completedTimeOptions" [value]="option">{{ option }}</option>
          </select>&nbsp;
          <select formControlName="timeFormat" class="ml-1" name="smsCompletedTimeFormat">
            <option *ngFor="let option of ['hours','minutes']" [value]="option">{{ option }}</option>
          </select>&nbsp;after someone is marked "served."
          </span>
          </label>
        </div>
        <div *ngIf="notificationsForm.get('smsCompleted.enabled').value">
          <div>
          <textarea
            name="smsCompleted"
            class="w-100 form-control"
            rows="5"
            replace-smart-punctuation
            formControlName="message"
            notify-channel="sms-completed"
            #smsCompletedMessage
            [class.is-invalid]="notificationsForm.get('smsCompleted.message').invalid && notificationsForm.get('smsCompleted.message').touched"
            trTrimSpaces
          ></textarea>
            <control-messages [control]="notificationsForm.get('smsCompleted.message')"></control-messages>
            <sms-warning [message]="smsCompletedMessage.value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="smsCompletedMessage.value"></chat-counter>
          </div>
        </div>
      </div>
    </div>
    <div class="row form-group" formGroupName="smsResConfirmation">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-sms-res-conf" class="col-form-label lead">{{location.displayOptions.labels.reservation | titlecase}} Confirmation SMS</label>
        <p>Sent automatically when you add a<span *ngIf="['a','e','i','o','u'].indexOf(location.displayOptions.labels.reservation.charAt(0)) > -1">n</span> {{location.displayOptions.labels.reservation}}.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
            <input type="checkbox"
                   class="form-check-input"
                   name="smsResConfirmationEnabled"
                   id="settings-sms-res-conf"
                   (ngModelChange)="toggleTextarea($event, 'smsResConfirmation')"
                   formControlName="enabled">Enabled
          </label>
        </div>
        <div *ngIf="notificationsForm.get('smsResConfirmation.enabled').value">
          <div>
          <textarea
            name="smsResConfirmation"
            class="w-100 form-control"
            rows="5"
            replace-smart-punctuation
            formControlName="message"
            notify-channel="sms-res-conf"
            #smsResConfirmationMessage
            [class.is-invalid]="notificationsForm.get('smsResConfirmation.message').invalid && notificationsForm.get('smsResConfirmation.message').touched"
            trTrimSpaces
          ></textarea>
            <control-messages [control]="notificationsForm.get('smsResConfirmation.message')"></control-messages>
            <sms-warning [message]="smsResConfirmationMessage.value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="smsResConfirmationMessage.value"></chat-counter>
          </div>
        </div>
      </div>
    </div>
    <div class="row form-group" formGroupName="smsReservationCancellation">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-sms-res-conf" class="col-form-label lead">{{location.displayOptions.labels.reservation | titlecase}} Cancellation Confirmation</label>
        <p>Sent automatically when a<ng-container *ngIf="['a','e','i','o','u'].indexOf(location.displayOptions.labels.reservation.charAt(0)) > -1">n</ng-container> {{location.displayOptions.labels.reservation}} is canceled.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
            <input
              type="checkbox"
              class="form-check-input"
              name="smsReservationCancellation"
              id="settings-sms-reservation-cancellation"
              (ngModelChange)="toggleTextarea($event, 'smsReservationCancellation')"
              formControlName="enabled">Enabled
          </label>
        </div>
        <div *ngIf="notificationsForm.get('smsReservationCancellation.enabled').value">
          <div>
          <textarea
            name="smsReservationCancellation"
            class="w-100 form-control"
            rows="5"
            replace-smart-punctuation
            formControlName="message"
            notify-channel="sms-reservation-cancellation"
            #smsReservationCancellationMessage
            [class.is-invalid]="notificationsForm.get('smsReservationCancellation.message').invalid && notificationsForm.get('smsReservationCancellation.message').touched"
            trTrimSpaces
          ></textarea>
            <control-messages [control]="notificationsForm.get('smsReservationCancellation.message')"></control-messages>
            <sms-warning [message]="smsReservationCancellationMessage.value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="smsReservationCancellationMessage.value"></chat-counter>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group" formGroupName="smsReminder">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-sms-reminder" class="col-form-label lead">{{location.displayOptions.labels.reservation | titlecase}} Reminder SMS</label>
        <p>Send this message automatically a set time before someone is scheduled.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
          <span>
            <input type="checkbox"
                   class="form-check-input"
                   name="smsReminderEnabled"
                   id="settings-sms-reminder"
                   (ngModelChange)="toggleTextarea($event, 'smsReminder')"
                   formControlName="enabled">
          </span>
            <span>
            Send this
            <select formControlName="timeValue" class="ml-1" name="smsCompletedTimeValue">
              <option *ngFor="let option of this.completedTimeOptions" [value]="option">{{ option }}</option>
            </select>&nbsp;
            <select formControlName="timeFormat" class="ml-1" name="smsCompletedTimeFormat">
              <option *ngFor="let option of ['days','hours','minutes']" [value]="option">{{ option }}</option>
            </select>&nbsp;before someone is scheduled to arrive.
          </span>
          </label>
        </div>
        <div *ngIf="notificationsForm.get('smsReminder.enabled').value">
          <div>
          <textarea
            name="smsReminder"
            class="w-100 form-control"
            rows="5"
            replace-smart-punctuation
            formControlName="message"
            notify-channel="sms-reminder"
            #smsReminderMessage
            [class.is-invalid]="notificationsForm.get('smsReminder.message').invalid && notificationsForm.get('smsReminder.message').touched"
            trTrimSpaces
          ></textarea>
            <control-messages [control]="notificationsForm.get('smsReminder.message')"></control-messages>
            <sms-warning [message]="smsReminderMessage.value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="smsReminderMessage.value"></chat-counter>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group" formGroupName="smsCheckinConfirmation">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-sms-checkin-confirmation" class="col-form-label lead">{{location.displayOptions.labels.reservation | titlecase}} Check-in Confirmation</label>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
            <input
              type="checkbox"
              class="form-check-input"
              name="smsCheckinConfirmation"
              id="settings-sms-checkin-confirmation"
              (ngModelChange)="toggleTextarea($event, 'smsCheckinConfirmation')"
              formControlName="enabled">Enabled
          </label>
        </div>
        <div *ngIf="notificationsForm.get('smsCheckinConfirmation.enabled').value">
          <div>
          <textarea
            name="smsCheckinConfirmation"
            class="w-100 form-control"
            rows="5"
            replace-smart-punctuation
            formControlName="message"
            notify-channel="sms-checkin-confirmation"
            #smsCheckinConfirmationMessage
            [class.is-invalid]="notificationsForm.get('smsCheckinConfirmation.message').invalid && notificationsForm.get('smsCheckinConfirmation.message').touched"
            trTrimSpaces
          ></textarea>
            <control-messages [control]="notificationsForm.get('smsCheckinConfirmation.message')"></control-messages>
            <sms-warning [message]="smsCheckinConfirmationMessage.value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="smsCheckinConfirmationMessage.value"></chat-counter>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="location.displayOptions.togo && account?.features?.togo" class="row form-group" formGroupName="toGoOrderConfirmation">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-sms-togo-conf" class="col-form-label lead">To Go Order Confirmation SMS</label>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
            <input
              type="checkbox"
              id="settings-sms-togo-conf"
              class="form-check-input"
              name="toGoOrderConfirmationEnabled"
              formControlName="enabled"
              (ngModelChange)="toggleTextarea($event, 'toGoOrderConfirmation')"
            >Enabled
          </label>
        </div>
        <div *ngIf="notificationsForm.get('toGoOrderConfirmation.enabled').value">
          <div>
          <textarea
            name="toGoOrderConfirmationMessage"
            class="w-100 form-control"
            rows="5"
            replace-smart-punctuation
            formControlName="message"
            notify-channel="sms-togo-order-conf"
            #toGoOrderConfirmationMessage
            [class.is-invalid]="notificationsForm.get('toGoOrderConfirmation.message').invalid && notificationsForm.get('toGoOrderConfirmation.message').touched"
            trTrimSpaces
          ></textarea>
            <control-messages [control]="notificationsForm.get('toGoOrderConfirmation.message')"></control-messages>
            <sms-warning [message]="toGoOrderConfirmationMessage.value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="toGoOrderConfirmationMessage.value"></chat-counter>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="location.displayOptions.togo && account?.features?.togo" class="row form-group" formGroupName="toGoOrderReady">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-togo-order-ready" class="col-form-label lead">To Go Order Ready SMS</label>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
            <input
              type="checkbox"
              class="form-check-input"
              name="toGoOrderReadyEnabled"
              id="settings-togo-order-ready"
              (ngModelChange)="toggleTextarea($event, 'toGoOrderReady')"
              formControlName="enabled">Enabled
          </label>
        </div>
        <div *ngIf="notificationsForm.get('toGoOrderReady.enabled').value">
          <div>
          <textarea
            name="toGoOrderReadyMessage"
            class="w-100 form-control"
            rows="5"
            replace-smart-punctuation
            formControlName="message"
            notify-channel="sms-togo-order-ready"
            #toGoOrderReadyMessage
            [class.is-invalid]="notificationsForm.get('toGoOrderReady.message').invalid && notificationsForm.get('toGoOrderReady.message').touched"
            trTrimSpaces
          ></textarea>
            <control-messages [control]="notificationsForm.get('toGoOrderReady.message')"></control-messages>
            <sms-warning [message]="toGoOrderReadyMessage.value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="toGoOrderReadyMessage.value"></chat-counter>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-3 offset-sm-3 offset-md-2">
        <button class="btn btn-success"
                type="submit"
                angularticsCategory="settings"
                angulartics2On="click"
                angularticsAction="Save Message Settings"
                [disabled]="notificationsForm.pristine || !notificationsForm.valid">Save
        </button>
      </div>
    </div>
  </form>

  <ng-container *ngIf="account.features.savedReplies">
    <h1 class="pt-3 mb-3">Saved replies</h1>
    <tablesready-replies-list
      [isMobile]="isMobile"
      [isOnBusinessPlan]="isLocationOnBusinessPlan"
      [customerPluralLabel]="location?.displayOptions.labels.customer_plural || 'parties'"
      (freePlanDetected)="freePlanConfirm()"
    ></tablesready-replies-list>
  </ng-container>
</section>
